import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { TableShell, Th, Td, EmptyRow } from "@/components/admin/DataTable";

export default function Recovery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/recovery").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const overdueTotal = items.reduce((s, r) => s + r.overdue_amount, 0);
  return (
    <AdminLayout title="Recovery">
      <div className="mb-4 grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-destructive/40 bg-card p-5"><p className="text-xs text-muted-foreground">Total Overdue</p><p className="font-display text-2xl font-extrabold text-destructive">{money(overdueTotal)}</p></div>
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs text-muted-foreground">Accounts in Recovery</p><p className="font-display text-2xl font-extrabold">{items.length}</p></div>
      </div>
      <TableShell>
        <thead className="border-b border-border bg-secondary/40"><tr><Th>Order</Th><Th>Customer</Th><Th>Mobile</Th><Th>Overdue Count</Th><Th>Overdue Amount</Th><Th>Next Due</Th></tr></thead>
        <tbody className="divide-y divide-border">
          {items.length === 0 ? <EmptyRow colSpan={6} text="No recovery accounts." /> : items.map((r) => (
            <tr key={r.order_id} className="hover:bg-secondary/30" data-testid={`recovery-row-${r.order_id}`}>
              <Td className="font-mono text-xs">{r.order_no}</Td><Td className="font-medium">{r.customer_name}</Td><Td>{r.mobile}</Td>
              <Td>{r.overdue_count > 0 ? <span className="font-semibold text-destructive">{r.overdue_count}</span> : "0"}</Td>
              <Td className="font-semibold">{money(r.overdue_amount)}</Td><Td>{r.next_due || "—"} · {money(r.next_amount)}</Td>
            </tr>
          ))}
        </tbody>
      </TableShell>
    </AdminLayout>
  );
}
